import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'

class Footer extends Component {
  render() {
    return (
      <div id="footer">
        <div className="container">
          <p className="">Valmet</p>
        </div>
      </div>
    )
  }
}

Footer.propTypes = {}

function mapStateToProps(state) {
  return {}
}

export default connect(mapStateToProps)(Footer)


// WEBPACK FOOTER //
// ./src/containers/Footer.js